import type { ColumnConfig } from "@/features/categories/components/category-views/shared/RemoteTableLayout";

export const AVAILABLE_COLUMNS: readonly ColumnConfig[] = [
  { id: "title", label: "Title" },
  { id: "company", label: "Company" },
  { id: "location", label: "Location" },
  { id: "sourceName", label: "Source" },
  { id: "firstSeenAt", label: "First Seen" },
  { id: "lastSeenAt", label: "Last Seen" },
  { id: "isActive", label: "Status" },
] as const;
